import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// Styles
import './Accordion.css';

const Accordion = ({
    title,
    children,
    className,
    open,
    onClick,
    openIcon,
    closeIcon,
}) => {
    const [showChildren, setShowChildren] = useState(open);
    const [iconSrc, setIconSrc] = useState();
    
    const handleClick = () => { 
        
        if (onClick) {
            onClick();
        } else {
            setShowChildren(! showChildren);
        }
    };

    useEffect(() => {
        // change to open does not re render this component, need it to rerender so as one opens, the other section closes
        setShowChildren(open)
    }, [open]);
    
    return ( 
        <Fragment>
            <div className={"collapsible-container accordion-container " + className + " " + (showChildren? 'open': '') }>
                <div 
                    className={`collapsible-container-accordion-header ${SG.INLINE_MIDDLE}`}
                    onClick={handleClick}
                > 
                    <h5 className={`title`}>{title}</h5>
                    <span className={`icon text-center`}>
                        <img src={showChildren ? openIcon : closeIcon} />
                    </span>                            
                </div>
                { showChildren && 
                    <div className="accordion-section content">
                        {children}
                    </div>
                }
            </div>
        </Fragment> 
    );
}
Accordion.defaultProps = {
    title: '',
    children: null,
    className: '',
    open: false,
    onClick: null,
    openIcon: '/images/mc/icon_arrow_up_black.png',
    closeIcon: '/images/mc/icon_arrow_down_black.png'
};

Accordion.propTypes = {
    // Any custom CSS class
    className: PropTypes.string,
    title:     PropTypes.string,

    openIcon: PropTypes.string,
    closeIcon: PropTypes.string
};

export default Accordion;
